let isMobile = false;
let mobileThreshold = 960;
//let mobileMenuToggle = document.querySelector('.js-mobile-menu');
let isTouch = 'ontouchstart' in document.documentElement;
let pdpTheme;

// Get the variable
const errorElement = document.querySelector('.error');
const inputMail = document.querySelector('#email');
const validRegex = new RegExp(
  /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
);

// Update cart reference when item is added to cart
$(document).on('cart.requestComplete', function (event, cart) {
  document.querySelector('.header__cart .cart-count').innerHTML =
    '(' + cart.item_count + ')';
});

window.addEventListener('load', event => {
  var showCart = getParameterByName('cart');
  if (showCart) {
    document.body.classList.toggle('show-cart');
  }

  //window.dispatchEvent(new Event('resize'));
});

(function () {
  checkIsMobile();

  // Popup
  if (document.querySelectorAll('.popup').length >= 1) {
    popupInit();
  }

  // Cart Init
  cartInit();
  sitewideInit();

  // Page inits
  if (document.body.classList.contains('customers-login')) {
    loginInit();
  }

  if (document.body.classList.contains('page-faq')) {
    faqInit();
  }

  // if (document.body.classList.contains('product')) {
  //   pdpInit();
  // }

  // if (document.body.classList.contains('product-sample')) {
  //   pdpSampleInit();
  // }
  if (
    document.querySelector('.pdp') &&
    document.querySelector('.pdp product-form') &&
    !document.body.classList.contains('codex-custom-product-page')
  ) {
    pdpInit();
  } else if (document.body.classList.contains('product-sample')) {
    pdpSampleInit();
  }
  // Block inits
  if (document.querySelectorAll('.hero-carousel').length >= 1) {
    heroCarouselInit();
  }
  if (document.querySelectorAll('.comparison-table').length >= 1) {
    comparisonTableInit();
  }
  if (document.querySelectorAll('.block--faq-panel').length >= 1) {
    faqModuleInit();
  }
  if (document.querySelectorAll('.block--facts').length >= 1) {
    factsInit();
  }
})();

function sitewideInit() {
  // Mobile menu
  let mobileToggle = document.querySelector('.js-toggle-menu');
  //let menuClose = document.querySelector('.js-menu-close');

  mobileToggle.addEventListener('click', function (e) {
    e.preventDefault();
    document.body.classList.toggle('mobile-menu-open');
  });
  /*
  menuClose.addEventListener('click', function (e) {
    e.preventDefault();
    document.body.classList.toggle('mobile-menu-open');
  });
  */

  // Footer form
  let footerForm = document.querySelector('.footer__form');
  let email = document.querySelector('.footer__input');
  let popupFormID = 'YyF9kn';

  footerForm.addEventListener('submit', function (e) {
    e.preventDefault();
    validateForm();
  });

  function validateForm() {
    let emailVal = email.value;
    let isValid = ValidateEmail(emailVal);

    if (isValid) {
      submitForm(popupFormID, emailVal, 'footer');
    } else {
      // error
    }
  }
}

function comparisonTableInit() {
  //let stepOneDiv = document.querySelector('.comparison-table__step-one');
  let stepTwoDiv = document.querySelector('.comparison-table__step-two');
  let breakfastOptions = document.querySelectorAll('.breakfast-option');
  let mealSelect = document.getElementById('meal-comparison');
  let selectedMeal;

  mealSelect.addEventListener('change', function () {
    selectedMeal = mealSelect.options[mealSelect.selectedIndex].value;
    let mealDiv = document.querySelector('.option--' + selectedMeal);

    breakfastOptions.forEach(div => {
      div.classList.add('d-none');
    });

    stepTwoDiv.classList.remove('d-none');
    mealDiv.classList.remove('d-none');

    window.scrollTo({ top: stepTwoDiv.offsetTop });
  });
}

function cartInit() {
  rivets.binders.src = function (el, value) {
    el.src = value;
  };

  rivets.formatters.currency = function (value) {
    //return '$' + (value / 100).toFixed(2);
    return '$' + value / 100;
  };

  rivets.formatters.equals = function (value, arg) {
    return value === arg;
  };

  rivets.formatters.notequals = function (value, arg) {
    return value !== arg;
  };

  rivets.formatters.removeClassSpaces = function (value) {
    return value.replace(/\s+/g, '-');
  };

  // Open cart
  document
    .querySelector('.js-cart-toggle')
    .addEventListener('click', function () {
      document.body.classList.toggle('show-cart');
    });

  // Close cart
  document
    .querySelector('.js-close-cart')
    .addEventListener('click', function () {
      document.body.classList.remove('show-cart');
    });

  // Close cart if clicking outside
  document.querySelector('.overlay--alt').addEventListener(
    'click',
    function (event) {
      if (!event.target.closest('.cart')) {
        document.body.classList.remove('show-cart');
      }
    },
    false
  );
}

// FAQ Module
function faqModuleInit() {
  let accToggle = document.querySelectorAll('.accordion__title');
  if (accToggle.length >= 1) {
    accToggle.forEach(item => {
      item.addEventListener('click', event => {
        toggleAccordion(item);
      });
    });
  }
}

// FAQ Page
function faqInit() {
  // Accordions
  let accToggle = document.querySelectorAll('.accordion__title');
  let secToggle = document.querySelectorAll('.js-section-toggle');
  let mobToggle = document.getElementById('faq-picker');

  if (accToggle.length >= 1) {
    accToggle.forEach(item => {
      item.addEventListener('click', event => {
        toggleAccordion(item);
      });
    });
  }

  secToggle.forEach(item => {
    item.addEventListener('click', event => {
      toggleSection(item, false);
    });
  });

  mobToggle.addEventListener('change', function () {
    let selectedCat = mobToggle.value;
    toggleSection(selectedCat, true);
  });
}

function toggleSection(item, isMobile) {
  let section;

  if (isMobile) {
    section = item;
  } else {
    section = item.getAttribute('data-section');
  }

  let sectionDiv = document.getElementById(section);
  let openSection = document.querySelector('.section-group.active');
  let activeToggle = document.querySelector('.js-section-toggle.active');

  if (!isMobile) {
    activeToggle.classList.remove('active');
    item.classList.add('active');
  }

  if (openSection) {
    openSection.classList.remove('active');
  }

  sectionDiv.classList.add('active');
}

function toggleAccordion(item) {
  let contentHeight = item.parentElement.querySelector(
    '.accordion__content__inner'
  ).offsetHeight;
  let openAccordion = document.querySelector('.accordion__title.open');

  // Check to one is open and close if so
  if (openAccordion) {
    openAccordion.classList.remove('open');
    openAccordion.parentElement.querySelector(
      '.accordion__content'
    ).style.maxHeight = 0;
  }

  // If open one is not clicked one, open it
  if (openAccordion != item) {
    item.parentElement.querySelector('.accordion__content').style.maxHeight =
      contentHeight + 'px';
    item.classList.add('open');
  }
}

function loginInit() {
  let forgotPassbtn = document.querySelector('.js-forgotten-password');
  let loginForm = document.querySelector('.js-login-show');
  let loginDivs = document.querySelectorAll('.js-login');
  let resetDivs = document.querySelectorAll('.js-reset');

  forgotPassbtn.addEventListener('click', function () {
    loginDivs.forEach(div => {
      div.classList.add('d-none');
    });
    resetDivs.forEach(div => {
      div.classList.remove('d-none');
    });
  });

  loginForm.addEventListener('click', function () {
    loginDivs.forEach(div => {
      div.classList.remove('d-none');
    });
    resetDivs.forEach(div => {
      div.classList.add('d-none');
    });
  });
}

function pdpSampleInit() {
  document.body.classList.remove('announcement-visible');
  if (document.querySelectorAll('.overlay--sign-up').length >= 1) {
    document.body.classList.add('sign-up-visible');

    let email = document.querySelector('.sign-up__input');
    let signUpForm = document.querySelector('.sign-up__form');
    let popupFormID = 'TfDtHC';

    signUpForm.addEventListener('submit', function (e) {
      e.preventDefault();
      validateForm();
    });

    function validateForm() {
      let emailVal = email.value;
      let isValid = ValidateEmail(emailVal);

      if (isValid) {
        submitForm(popupFormID, emailVal, 'sample');
        document.body.classList.remove('sign-up-visible');
        document.body.classList.add('sign-up-success');
      } else {
        // error
      }
    }
  }

  let cartBtns = document.querySelectorAll('.js-add-to-cart');

  cartBtns.forEach(cartBtn => {
    cartBtn.addEventListener('click', function (e) {
      let prodId = cartBtn.getAttribute('data-id');
      CartJS.addItem(prodId, 1);

      // Open cart
      setTimeout(function () {
        document.body.classList.toggle('show-cart');
      }, 1000);
    });
  });
}

function pdpInit() {
  let flavOptions = document.querySelectorAll('.variant__group--flavor input');
  let flavLabel = document.querySelectorAll(
    '.variant__group--flavor label.variant'
  );
  let packSize = document.querySelectorAll('.variant__group--size input');
  let subscriptionOpts = document.querySelectorAll('.subscribe-option');
  //let flavLabels = document.querySelectorAll('.variant__group--flavor .variant');
  let ingredients = document.querySelectorAll('.ingredients__item');
  let selectFlav = document.querySelector('.selected-flavor');
  let curFlavor = selectFlav.getAttribute('data-variant');
  let curFlavorVal = selectFlav.innerHTML;
  let badge = document.querySelector('.pdp__badge');
  let badgeVal = document.querySelector('.pdp__badge span');
  let cartBtn = document.querySelector('.js-add-to-cart');
  let isSubscription = false;
  let hasSellingPlan = false;
  let subscriptionOpt = document.getElementById('subscribe');
  let oneTimePurchase = document.getElementById('onetime');
  let isPreoderString = document
    .querySelector('product-form')
    .getAttribute('data-preorder');
  let isPreorder = isPreoderString === 'true';
  let preorderShipDate = document
    .querySelector('product-form')
    .getAttribute('data-ship-date');

  // Run variant checks on load as first available product might change
  updateVariantId();

  // Set initial option to true
  subscriptionOpt.checked = true;
  updateSubscription('subscribe');
  //oneTimePurchase.checked = true;
  
  // Set 12-pack to default
  packSize[1].checked = true;
  updateVariantId();
  updatePackSize(packSize[1]);

  // Initialise PDP image carousel
  const pdpCarousel = new Swiper('.pdp__carousel', {
    mousewheel: {
      sensitivity: 3,
      enabled: true,
    },
    loop: true,
    speed: 500,
    autoplay: {
      delay: 3000,
      pauseOnMouseEnter: true,
    },
    pagination: {
      el: '.pdp__carousel__pagination',
      clickable: true,
    },
    breakpoints: {
      960: {
        direction: 'vertical',
      },
    },
  });

  // pdpCarousel.on('scroll', function (swiper) {
  //   console.log('scroll');
  // });

  pdpCarousel.on('slideChange', function (swiper) {
    // Update badge
    if (swiper.realIndex == 0) {
      badge.classList.remove('hidden');
    } else {
      badge.classList.add('hidden');
    }

    if (swiper.realIndex == 1) {
      document
        .querySelector('.pdp__list__items:first-child')
        .classList.remove('hidden');
    } else {
      document
        .querySelector('.pdp__list__items:first-child')
        .classList.add('hidden');
    }

    if (swiper.realIndex == 2) {
      document
        .querySelector('.pdp__list__items:nth-child(2)')
        .classList.remove('hidden');
    } else {
      document
        .querySelector('.pdp__list__items:nth-child(2)')
        .classList.add('hidden');
    }

    if (swiper.realIndex == 3) {
      document
        .querySelector('.pdp__list__items:nth-child(3)')
        .classList.remove('hidden');
    } else {
      document
        .querySelector('.pdp__list__items:nth-child(3)')
        .classList.add('hidden');
    }
    //console.log(swiper.realIndex);
  });

  // Update pack Size
  packSize.forEach(input => {
    input.addEventListener('change', function () {
      updateVariantId();

      if (input.checked) {
        updatePackSize(input);
      }
    });
  });

  // Update Pack Size function
  function updatePackSize(input) {
    // Update badge text
    let newVal = input.value.split('-', 1)[0];
    badgeVal.innerHTML = newVal;
    document
      .querySelector('.variant__group--size label.active')
      .classList.remove('active');
    input.parentNode.classList.add('active');
  }

  // Update Images
  function updateSwiper(flavHandle) {
    pdpCarousel.disable();
    let newImgs = [];
    let imgCount = 1;

    allImages.forEach(function (item, index) {
      const flav = item.flavour;
      if (flav.includes(flavHandle)) {
        let swiperDiv = document.createElement('div');
        //swiperDiv.setAttribute('thumbnail-alt', item.colour);
        swiperDiv.classList.add('swiper-slide');
        if (imgCount == 1) {
          swiperDiv.classList.add('swiper-slide-active');
        }
        swiperDiv.innerHTML =
          '<img src="' +
          item.img +
          '" width="2000" height="2000" alt="' +
          item.alt +
          '" />';
        newImgs.push(swiperDiv);
        imgCount++;
      }
    });

    pdpCarousel.removeAllSlides();

    pdpCarousel.addSlide(1, newImgs);
    pdpCarousel.slideTo(0);
    
    pdpCarousel.updateSlides();
    pdpCarousel.update();
    pdpCarousel.enable();
  }

  subscriptionOpts.forEach(opt => {
    opt.addEventListener('change', function () {
      let subscribeType = opt.value;
      updateSubscription(subscribeType);
    });
  });

  flavOptions.forEach(option => {
    // set initial theme
    if (option.checked) {
      manageTheme(option);
    }

    option.addEventListener('change', function () {
      manageTheme(option);
      updateVariantId();
    });
  });

  // Handle flavor labels hover state
  flavLabel.forEach(label => {
    let flavClean = label.querySelector('input').value;

    label.addEventListener('mouseover', function () {
      selectFlav.innerHTML = flavClean;
    });

    label.addEventListener('mouseout', function () {
      selectFlav.innerHTML = curFlavorVal;
    });
  });

  // Handle theme colours and text
  function manageTheme(option) {
    let flavClean = option.value;
    let flavHandle = option.getAttribute('data-variant');
    let activeLabel = document.querySelector(
      '.variant__group--flavor .variant.active'
    );

    document.body.classList.remove('theme--' + curFlavor);
    activeLabel.classList.remove('active');

    option.parentNode.classList.add('active');
    selectFlav.innerHTML = flavClean;
    curFlavorVal = flavClean;
    document.body.classList.add('theme--' + flavHandle);

    if (curFlavor == flavHandle) {
      return;
    } else {
      curFlavor = flavHandle;
      updateSwiper(flavHandle);
    }

    manageIngredients();

    // Show / Hide carousel thumbs based on selected variant colour
  }

  // Handle ingredients
  function manageIngredients() {
    ingredients.forEach(ing => {
      let relatedIng = ing.getAttribute('data-related');
      let isRelated = relatedIng.includes(curFlavor);
      ing.classList.remove('active');
      if (isRelated) {
        ing.classList.add('active');
      }
    });

    // Get all active items and mark the last one
    const activeItems = [...ingredients].filter(ing => ing.classList.contains('active'));
    if (activeItems.length > 0) {
      activeItems[activeItems.length - 1].classList.add('last-active');
    }
  }

  // Add to cart
  cartBtn.addEventListener('click', function (e) {
    e.preventDefault();
    cartBtn.setAttribute('disabled', true);
    cartBtn.innerHTML = 'Item Added';
    let prodId = cartBtn.getAttribute('data-id');
    let planId = cartBtn.getAttribute('data-selling-plan-id');

    //console.log(prodId, planId);

    if (isSubscription) {
      // Add subscription
      if (isPreorder) {
        CartJS.addItem(prodId, 1, {
          selling_plan: planId,
          Preorder: 'Ship ' + preorderShipDate,
        });
      } else {
        CartJS.addItem(prodId, 1, {
          selling_plan: planId,
        });
      }
    } else {
      // Add one time purchase
      if (isPreorder) {
        CartJS.addItem(prodId, 1, {
          Preorder: true,
        });
      } else {
        CartJS.addItem(prodId, 1);
      }
    }

    // Open cart
    setTimeout(function () {
      document.body.classList.toggle('show-cart');
      cartBtn.removeAttribute('disabled');
      if (isPreorder) {
        cartBtn.innerHTML = 'Pre-order';
      } else {
        cartBtn.innerHTML = 'Add to Cart';
      }
    }, 1000);
  });

  // Get Variant ID
  function updateVariantId() {
    let optFlavor = document.querySelector(
      '.variant__group--flavor .variant input:checked'
    );
    let optSize = document.querySelector(
      '.variant__group--size .variant input:checked'
    );
    let prodJson = JSON.parse(
      document.querySelector('[data-product-json]').innerHTML
    );

    let prodId;
    let sellingPlanId;
    let isAvailable = false;

    let opt1 = optFlavor.value;
    let opt2 = optSize.value;
    let opt3 = null;

    for (var i = 0; i < prodJson.length; i++) {
      if (
        prodJson[i].option1 == opt1 &&
        prodJson[i].option2 == opt2 &&
        prodJson[i].option3 == opt3
      ) {
        prodId = prodJson[i].id;
        hasSellingPlan = prodJson[i].selling_plan_allocations.length > 0;
        isAvailable = prodJson[i].available;
        updateVariantUrl(prodId);
        //console.log(hasSellingPlan);

        // If variant has subscription
        if (hasSellingPlan) {
          sellingPlanId =
            prodJson[i].selling_plan_allocations[0].selling_plan_id;
          if (isAvailable) {
            cartBtn.setAttribute('data-selling-plan-id', sellingPlanId);
          }

          subscriptionOpts.forEach(opt => {
            opt.removeAttribute('disabled');
            opt.parentNode.classList.remove('disabled');
          });
        } else {
          // Disable subscribe option
          subscriptionOpts.forEach(opt => {
            if (opt.value == 'subscribe') {
              opt.setAttribute('disabled', true);
              opt.parentNode.classList.add('disabled');
            }
            if (opt.value == 'one-time') {
              opt.checked = true;
            }
          });

          // Hide subscription pricing
          document
            .querySelector('.variant__group--size')
            .classList.remove('subscription-pricing');
        }

        if (isAvailable) {
          cartBtn.setAttribute('data-id', prodId);
          cartBtn.removeAttribute('disabled');
          if (isPreorder) {
            cartBtn.innerHTML = 'Pre-order';
          } else {
            cartBtn.innerHTML = 'Add to cart';
          }
        } else {
          cartBtn.setAttribute('disabled', true);
          cartBtn.innerHTML = 'Sold Out';
        }

        //console.log(prodId, prodJson[i].title)

        break;
      }
    }

    updateProductPrice(prodId);
    //checkAvailable(prodId, opt1, opt2, opt3);
  }

  function updateVariantUrl(variantId) {
    if (!variantId || !window.history || !window.history.replaceState) {
      return;
    }

    let currentUrl = new URL(window.location.href);

    if (currentUrl.searchParams.get('variant') == String(variantId)) {
      return;
    }

    currentUrl.searchParams.set('variant', variantId);
    window.history.replaceState({}, '', currentUrl.toString());
  }

  function updateSubscription(subscribeType) {
    let prodId = document
      .querySelector('.js-add-to-cart')
      .getAttribute('data-id');
    let sizeContainer = document.querySelector('.variant__group--size');

    if (subscribeType == 'one-time') {
      isSubscription = false;
      sizeContainer.classList.remove('subscription-pricing');
    } else if (subscribeType == 'subscribe') {
      isSubscription = true;
      sizeContainer.classList.add('subscription-pricing');
    }

    updateVariantId(prodId);
  }

  // Update price based on selection
  function updateProductPrice(prodId) {
    let prodJson = JSON.parse(
      document.querySelector('[data-product-json]').innerHTML
    );
    let priceElm = document.querySelector(
      '.product-form__footer .price .value'
    );
    let compareElm = document.querySelector(
      '.product-form__footer .price .compare '
    );
    let prodPrice;
    let comparePrice;

    if (isSubscription) {
      compareElm.classList.remove('hidden');
    } else {
      compareElm.classList.add('hidden');
    }

    for (var i = 0; i < prodJson.length; i++) {
      if (prodJson[i].id == prodId) {
        if (isSubscription && hasSellingPlan) {
          prodPrice = prodJson[i].selling_plan_allocations[0].price;
          comparePrice = prodJson[i].price;
        } else {
          prodPrice = prodJson[i].price;
        }
        break;
      }
    }
    compareElm.innerHTML = '$' + (comparePrice / 100).toFixed(2);
    priceElm.innerHTML = '$' + (prodPrice / 100).toFixed(2);
  }
} // Close PDP

// Check if variant is available
function checkAvailable(prodId, opt1, opt2, opt3) {}

function heroCarouselInit() {
  const imageSwiper = new Swiper('.hero-carousel__carousel', {
    mousewheel: {
      sensitivity: 5,
      enabled: true,
    },
    speed: 500,
    loop: true,
    autoplay: {
      delay: 3000,
      pauseOnMouseEnter: true,
    },
    pagination: {
      el: '.hero-carousel__pagination',
      clickable: true,
    },
    breakpoints: {
      960: {
        direction: 'vertical',
      },
    },
  });
}

async function submitForm(formId, emailVal, formType) {
  let success = document.querySelector('.popup__success');
  let form = document.querySelector('.popup__subscribe');
  let source;
  if (formType === 'popup') {
    source = 'Promotional Signup';
  } else if (formType === 'footer') {
    source = 'Footer Signup';
  } else if (formType === 'sample') {
    source = 'Free Sample Signup';
  }
  const data = {
    g: formId,
    $fields: '$source',
    email: emailVal,
    $source: source,
  };
  const urlData = new URLSearchParams(data);
  const response = await fetch(
    'https://manage.kmail-lists.com/ajax/subscriptions/subscribe',
    {
      method: 'POST',
      body: urlData,
    }
  );

  if (response.status === 200) {
    if (formType === 'popup') {
      form.classList.add('d-none');
      success.classList.remove('d-none');

      setTimeout(function () {
        closePopup(true);
      }, 3000);
    }
    if (formType === 'footer') {
      let footerFormContainer = document.querySelector(
        '.footer__form .form__field'
      );
      let submitBtn = document.querySelector('.footer__form .btn');
      let successMessage = document.createElement('p');
      successMessage.classList.add('footer__signup__thankyou');
      successMessage.innerHTML = 'Thank you for signing up!';

      document.querySelector('.footer__form .heading-3').after(successMessage);
      submitBtn.classList.add('d-none');
      footerFormContainer.classList.add('d-none');
    }
  } else {
    console.log('error', response);
  }
}

function checkIsMobile() {
  let viewPort = window.innerWidth;

  if (viewPort <= mobileThreshold) {
    isMobile = true;
  } else {
    isMobile = false;
  }
}

function getParameterByName(name, url) {
  if (!url) url = window.location.href;
  name = name.replace(/[\[\]]/g, '\\$&');
  var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
    results = regex.exec(url);
  if (!results) return null;
  if (!results[2]) return '';
  return decodeURIComponent(results[2].replace(/\+/g, ' '));
}

// Popup
function popupInit() {
  let email = document.querySelector('.popup__email');
  let close = document.querySelector('.popup__close');
  let form = document.querySelector('.popup__subscribe');
  let popupFormID = 'YyF9kn';

  if (readCookie('popupClosed') != '1') {
    showPopup();
  }

  form.addEventListener('submit', function (e) {
    e.preventDefault();
    validateForm();
  });

  // Close cart if clicking outside
  document.querySelector('.overlay--alt').addEventListener(
    'click',
    function (event) {
      if (!event.target.closest('.pop-up')) {
        closePopup(false);
      }
    },
    false
  );

  close.addEventListener('click', function (e) {
    closePopup(false);
  });

  function validateForm() {
    let emailVal = email.value;
    let isValid = ValidateEmail(emailVal);

    if (isValid) {
      submitForm(popupFormID, emailVal, 'popup');
    } else {
      // error
    }
  }
}

function showPopup() {
  document.body.classList.add('popup-visible');
}

function closePopup(isSuccess) {
  document.body.classList.remove('popup-visible');
  if (isSuccess) {
    createCookie('popupClosed', '1', 30); // 1 month
  } else {
    createCookie('popupClosed', '1', 1); // 1 day
  }
}

function createCookie(name, value, days) {
  var expires = '';
  if (days) {
    var date = new Date();
    date.setTime(date.getTime() + 1 * 24 * 60 * 60 * 1000 * days);
    expires = '; expires=' + date.toUTCString();
  }
  document.cookie = name + '=' + value + expires + '; path=/'; // affects all site pages
}

function readCookie(name) {
  var nameEQ = name + '=';
  var ca = document.cookie.split(';');

  for (var i = 0; i < ca.length; i++) {
    var c = ca[i];
    while (c.charAt(0) == ' ') c = c.substring(1, c.length);
    if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
  }
  return null;
}

function ValidateEmail(inputText) {
  if (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(inputText)) {
    //console.log(inputText, 'is valid');
    return true;
  } else {
    //console.log(inputText, 'is NOT valid');
    return false;
  }
}

function toggleNutritionModal() {
  document.body.classList.toggle('modal-visible');
}

function factsInit() {
  let factCloseBtn = document.querySelector('.modal__close');
  let factBtn = document.querySelectorAll('.modal__tab');
  let modalContent = document.querySelectorAll('.modal__content .fact');

  factCloseBtn.addEventListener('click', function () {
    console.log('close');
    toggleNutritionModal();
  });

  factBtn.forEach(btn => {
    btn.addEventListener('click', function () {
      let flavour = btn.getAttribute('data-flavour');
      let newContent = document.querySelector(
        '.fact[data-flavour="' + flavour + '"]'
      );

      modalContent.forEach(div => {
        div.classList.add('hidden');
      });

      newContent.classList.remove('hidden');
    });
  });

  // Close cart if clicking outside
  document.querySelector('.overlay--facts').addEventListener(
    'click',
    function (event) {
      if (!event.target.closest('.modal')) {
        document.body.classList.remove('modal-visible');
      }
    },
    false
  );
}
